import { ForwardOutlined } from '@mui/icons-material';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';

import { useState } from 'react';

import { useRouter } from 'next/navigation';

import { graphql, type DocumentType } from '@/gql';

import { useGetFileUrl } from '@/modules/files/hooks/useGetFileUrl';

import { ShareFileToNoticeboardDialog } from './share-file-to-noticeboard-menu-item/ShareFileToNoticeboardDialog';

const SHARE_FILE_ON_NOTICEBOARD_MENU_ITEM_FILE_FRAGMENT = graphql(`
  fragment shareFileOnNoticeboardMenuItemFields on File {
    ...ShareFileToNoticeboardDialogFileFields
    _id
    filename
  }
`);

const SHARE_FILE_ON_NOTICEBOARD_MENU_ITEM_FILES_FOR_OWNER_FRAGMENT = graphql(`
  fragment shareFileOnNoticeboardMenuItemFilesForOwnerFields on FilesForOwner {
    ...ShareFileToNoticeboardDialogFilesForOwnerFields
    owner {
      ... on Group {
        _id
        machineName
      }
      ... on Service {
        _id
        machineName
      }
    }
  }
`);

interface Props {
  file: DocumentType<typeof SHARE_FILE_ON_NOTICEBOARD_MENU_ITEM_FILE_FRAGMENT>;
  filesForOwner: DocumentType<
    typeof SHARE_FILE_ON_NOTICEBOARD_MENU_ITEM_FILES_FOR_OWNER_FRAGMENT
  >;
  onClose: () => void;
}

export const ShareFileOnNoticeboardMenuItem = ({
  file,
  filesForOwner,
  onClose,
}: Props) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const router = useRouter();

  const { filename } = file;
  const { owner } = filesForOwner;
  const { machineName } = owner ?? {};

  const getFileUrl = useGetFileUrl({
    type: 'Group',
    machineName: machineName ?? '',
  });

  const searchParams = new URLSearchParams();

  searchParams.set('prefillTitle', filename ?? '');
  searchParams.set('prefillHref', getFileUrl(file));

  return (
    <>
      <MenuItem
        onClick={() => {
          if (owner.__typename === 'Group') {
            router.push(
              `/g/${machineName}/noticeboard?${searchParams.toString()}`,
            );
          } else {
            setDialogOpen(true);
          }
          onClose();
        }}
      >
        <ListItemIcon>
          <ForwardOutlined />
        </ListItemIcon>
        <ListItemText primary="Share on Noticeboard" />
      </MenuItem>
      <ShareFileToNoticeboardDialog
        file={file}
        filesForOwner={filesForOwner}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
